import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AppTableOptions } from '@app/shared/model/table/appTableOptions.model';
import { AuthService } from '@app/core/auth/auth.service';
import { SpinnerService } from '@app/core/spinner/spinner.service';
import { InfoService } from '@app/core/info/info.service';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActionCV } from '@app/shared/model/cv/ActionCV.model';
import { Worklog } from '@app/shared/model/entity/worklog.model';
import { AbstractNoEntityTableComponent } from '../app-table/abstractNoEntityTableComponents';
import { DateUtil } from '@app/shared/util/DateUtil.model';
import { ConfirmationResponse } from '@app/core/confirmation/confirmationResponse.model';
import { ConfirmationService } from '@app/core/confirmation/confirmation.service';
import { EntityInterface } from '@app/shared/model/entity/interfaces/entityInterface.model';
import { WorklogService } from '@app/shared/service/worklog.service';
import { finalize, pipe } from 'rxjs';
import { Element } from '@app/shared/model/entity/element.model';
import { EntityCV } from '@app/shared/model/cv/EntityCV.model';

@Component({
  selector: 'app-worklog',
  templateUrl: './app-worklog.component.html',
  styleUrls: ['./app-worklog.component.scss']
})
export class AppWorklogComponent extends AbstractNoEntityTableComponent {
  
  @Input() worklogs: Array<Worklog>;
  @Input() entity: EntityInterface;
  @Input() element: Element;

  public static all: EntityCV = new EntityCV();

  actionFilter: string;

  constructor(
    authService: AuthService,
    spinner: SpinnerService,
    info: InfoService,
    modalService: NgbModal,
    translateService: TranslateService,
    confirmationService: ConfirmationService,
    public worklogService: WorklogService
  ) {
    super(authService, spinner, info, modalService, false, false, translateService, null, false, confirmationService);
  }

  doFilter(): void {
  }

  doRemoveFilter(): void {
  }

  getAppTableOptions(): AppTableOptions {
    return {
      scrollY: '250px',
      scrollCollapse: false,
      paging: false,
      keys: true,
      mark: true,
      order: [[2, 'desc']],
      select: false,
      dom: 'rt',
      info: false,
      columnDefs: [
        {
          targets: [0],
          visible: false,
          searchable: false
        },
        {
          targets: [1],
          render: (data: string, type: string): string => {
            if (type === 'display') {
              if (data === ActionCV.all.SHORT_INSERT) {
                return `<i class="fas fa-plus" title="${this.translateService.instant('entity.worklog.action.I') as string}"></i>`;
              } else if (data === ActionCV.all.SHORT_UPDATE) {
                return `<i class="fas fa-edit" title="${this.translateService.instant('entity.worklog.action.U') as string}"></i>`;
              } else if (data === ActionCV.all.SHORT_ACTIVATE) {
                return `<i class="fas fa-toggle-on" title="${this.translateService.instant('entity.worklog.action.A') as string}"></i>`;
              } else if (data === ActionCV.all.SHORT_DEACTIVATE) {
                return `<i class="fas fa-toggle-off fa-2x " title="${this.translateService.instant('entity.worklog.action.X') as string}"></i>`;
              } else if (data === ActionCV.all.SHORT_ADD_EXPIRE) {
                return `<i class="far fa-calendar-times" title="${this.translateService.instant('entity.worklog.action.AV') as string}"></i>`;
              } else if (data === ActionCV.all.SHORT_REMOVE_EXPIRE) {
                return `<i class="far fa-calendar-check" title="${this.translateService.instant('entity.worklog.action.XV') as string}"></i>`;
              }
            } else if (type === 'sort') {
              if (data === ActionCV.all.SHORT_INSERT) {
                return '4';
              } else if (data === ActionCV.all.SHORT_UPDATE) {
                return '3';
              } else if (data === ActionCV.all.SHORT_ACTIVATE) {
                return '1';
              } else if (data === ActionCV.all.SHORT_DEACTIVATE) {
                return '2';
              } else if (data === ActionCV.all.SHORT_ADD_EXPIRE) {
                return '5';
              } else if (data === ActionCV.all.SHORT_REMOVE_EXPIRE) {
                return '6';
              }
            } else {
              return data;
            }
          }
        },
        {
          targets: [2],
          render: (data: Date, type: string): string => {
            if (type === 'display') {
              return DateUtil.getDateTimeFormatFromDate(data);
            } else {
              return data.toString();
            }
          }
        }
      ],
      columns: [
        { data: 'id'},
        { data: 'action'},
        { data: 'updateDatetime'},
        { data: 'updateUsername'},
        { data: 'comment'}
      ]
    };
  }
  getFilterForm(): FormGroup {
    return null;
  }
  onInit(): void {
    // if (this.element && this.element.workLogs) {
      // this.entities = this.element.workLogs;
    if (this.worklogs) {
      this.entities = this.worklogs;
    } else {
      this.entities = [];
    }
  }

  afterViewInit(): void {
    this.tableChange(this.entities);
  }

  filterAction(action?: string): void {
    if (!action) {
      action = '';
    }
    this.actionFilter = action;
    this.appTable.columnSearch(1, action);
    this.appTable.draw();
  }

  changeTab(): void {
    this.appTable.resizeColumns(300);
    this.appTable.draw();
  }

  newComment(): void {
    this.confirmationService.confirm(`common.confirmation.${ActionCV.all.INSERT}`, null, true)
        .then((confirmResponse: ConfirmationResponse) => {
          if (confirmResponse && confirmResponse.ok) {
            this.spinner.startSpinner('entity.worklog.action.I');

            const worklog = new Worklog();
            worklog.comment = confirmResponse.comment;
            worklog.action = "I";
            worklog.element =  this.element;
            // worklog.elementRef = this.worklogs[0].id;

          this.worklogService.create(worklog, true)
          .pipe(finalize(() => {
              this.spinner.stopSpinner();
            }))
          .subscribe({
              next: (worklogReturn: Worklog) => {
                this.worklogs.push(worklogReturn);
                this.tableChange(this.worklogs);
                this.infoService.showInfo('entity.worklog.actions.insert.ok');
              },
              error: () => {
                console.error(`Service return error`);
              }
            });
          }
        })
  }

  isNewAllowed(): boolean {
    if (this.element != null && this.element.entityType == EntityCV.all.OPERATOR) {
      return true;
    } 
    return false;
  }

}
